import { createContext, useContext } from 'react';

import type { ApiError } from '../../../../../lib/apiError';

/**
 * `saving` and the field errors, shared from the section shell down to a section's fields so
 * each one does not have to be handed them.
 *
 * Its own file rather than an export beside `<PersonnelSectionModal>`: a module that exports
 * both components and non-components breaks fast refresh, which is the warning oxlint raises
 * — and `<PasswordFields>` carries the same one for the same reason.
 */
export const PersonnelSectionContext = createContext<{ saving: boolean; error: ApiError | null }>({
  saving: false,
  error: null,
});

export function useSectionForm() {
  return useContext(PersonnelSectionContext);
}
